import { Button } from '@mui/material';
import { AutomaticFeedbackBanner } from 'components/my/purchases/AutomaticFeedbackBanner';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  canLeaveFeedback?: boolean;
  feedbackIdForSeller?: number | null;
  automaticFeedbackForSeller?: boolean;
  shopSlug?: string;
  onLeaveFeedback: () => void;
  buttonSize?: 'small' | 'medium' | 'large';
  className?: string;
};

export const PurchaseFeedbackAction = ({
  canLeaveFeedback,
  feedbackIdForSeller,
  automaticFeedbackForSeller,
  shopSlug,
  onLeaveFeedback,
  buttonSize = 'large',
  className = 'mt-2',
}: Props) => {
  const { t } = useTranslation();

  if (canLeaveFeedback) {
    return (
      <div className={className}>
        <Button variant="outlined" size={buttonSize} fullWidth onClick={onLeaveFeedback}>
          {t('components.feedback.leave-feedback')}
        </Button>
      </div>
    );
  }

  if (feedbackIdForSeller && automaticFeedbackForSeller && shopSlug) {
    return (
      <div className={className}>
        <AutomaticFeedbackBanner shopSlug={shopSlug} />
      </div>
    );
  }

  return null;
};
